import React from 'react';
import { Switch, Redirect, Route, NavLink } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';

import PricingSummary from 'modules/pricing-summary';
import PricingCreate from 'modules/pricing-create';

import * as routes from 'routes';

const strategies = {
  ES_SH: {
    title: 'Spain (ES) Short Haul',
    url: `${routes.PRICING_ROUTE}/ES_SH`
  },
  ES_LH: {
    title: 'Spain (ES) Long Haul',
    url: `${routes.PRICING_ROUTE}/ES_LH`
  },
  ES_XDOCK: {
    title: 'Spain (ES) Cross-Dock',
    url: `${routes.PRICING_ROUTE}/ES_XDOCK`
  },
  UK_SH: {
    title: 'United Kingdom (UK) Short Haul',
    url: `${routes.PRICING_ROUTE}/UK_SH`
  },
  UK_LH: {
    title: 'United Kingdom (UK) Long Haul',
    url: `${routes.PRICING_ROUTE}/UK_LH`
  },
  FR_SH: {
    title: 'France (FR) Short Haul',
    url: `${routes.PRICING_ROUTE}/FR_SH`
  },
  FR_LH: {
    title: 'France (FR) Long Haul',
    url: `${routes.PRICING_ROUTE}/FR_LH`
  },
  FR_XDOCK: {
    title: 'France (FR) Cross-Dock',
    url: `${routes.PRICING_ROUTE}/FR_XDOCK`
  },
  NL_SH: {
    title: 'Netherlands (NL) Short Haul',
    url: `${routes.PRICING_ROUTE}/NL_SH`
  },
  NL_LH: {
    title: 'Netherlands (NL) Long Haul',
    url: `${routes.PRICING_ROUTE}/NL_LH`
  },
  NL_XDOCK: {
    title: 'Netherlands (NL) Cross-Dock',
    url: `${routes.PRICING_ROUTE}/NL_XDOCK`
  },
  EU_LH: {
    title: 'Default (EU) Long Haul',
    url: `${routes.PRICING_ROUTE}/EU_LH`
  }
};

const PricingPage = React.memo(() => {
  return (
    <Container className="mt-4">
      <Row>
        <Col sm={3}>
          <Nav variant="pills" className="flex-column">
            {Object.keys(strategies).map(strategy => (
              <Nav.Item key={strategy}>
                <Nav.Link as={NavLink} to={strategies[strategy].url}>
                  {strategies[strategy].title}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Col>
        <Col sm={9}>
          <Tab.Content>
            <Switch>
              <Redirect exact path={routes.PRICING_ROUTE} to={routes.PRICING_ROUTE_DEFAULT} />
              <Route exact path={`${routes.PRICING_ROUTE}/:strategy`} component={PricingSummary} />
              <Route
                exact
                path={`${routes.PRICING_ROUTE}/:strategy/create`}
                component={PricingCreate}
              />
            </Switch>
          </Tab.Content>
        </Col>
      </Row>
    </Container>
  );
});

export default PricingPage;
